module.exports = "<div class=\"word-container\">\r\n    <button class=\"btn btn-raised btn-default answer\"  *ngFor='let part of Sentence'\r\n    (click)=\"deselect(part)\">\r\n    {{part.text}}\r\n    </button>    \r\n</div>\r\n\r\n<h3>Choose from the following words</h3>\r\n<div class=\"word-container\">\r\n    <button class=\"btn btn-raised btn-default answer\"  *ngFor='let part of Options'\r\n        (click)=\"select(part)\">\r\n    {{part.text}}\r\n    </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/quiz/question/question-sentence/question-sentence.component.html
// module id = 474
// module chunks = 1